import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IReport } from '@interfaces/index';
import { ConsentService } from '@ui-components/consent';

@Component({
  selector: 'app-video-guide',
  templateUrl: './video-guide.component.html',
  styleUrls: ['./video-guide.component.scss']
})
export class VideoGuideComponent implements OnInit {
  @Input() videoUrl: string = 'https://player.vimeo.com/video/994620459?h=24e482bf9f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';
  sanitizedVideoUrl!: SafeResourceUrl;
  @Input() report!: IReport;
  @Input() download = false;

  constructor(private sanitizer: DomSanitizer, public consent: ConsentService) {}

  ngOnInit(): void {
    this.sanitizedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
  }
}
